export default {
  // удаление всех символов кроме букв, в том числе двойных пробелов
  driverNormalize(driver) {
    const regexp = /[^а-яёa-z]/gi
    const splitted = driver
      .split(" ")
      .map(c => c.replace(regexp, ""))
      .filter(c => c.length)
    return splitted.join(" ")
  },

  // удаление всех символов кроме букв, цифр и /
  carNumberNormalize(car) {
    return car.length ? car.replace(/[^а-яёa-z\d/]/gi, "") : car
  },

  // сокращение полных ФИО до Фамилия И.О.
  shortFIO(value) {
    if (!value) return ""
    const words = value.split(" ")
    let result = words[0]
    if (words.length > 1) {
      result += " "
      for (let i = 1; i < words.length; i++) {
        result += `${words[i][0]}.`
      }
    }
    return result
  }
}
